import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import navbar from '../blocks/navbar/navbar';
import loader from '../blocks/loader/loader';
import slider from '../blocks/slider/slider';
import sliderResizable from '../blocks/slider-resizable/slider-resizable';
import formContact from '../blocks/form-contact/form-contact';
import formModal from '../blocks/form-modal/form-modal';
import formStatus from '../blocks/form-status/form-status';
import formPopup from '../blocks/form-popup/form-popup';
import faqlist from '../blocks/faq-list/faq-list';
import formList from '../blocks/form-list/form-list';
import formDirections from '../blocks/form-directions/form-directions';
import tvList from '../blocks/tv-list/tv-list';
import formCallback from '../blocks/form-callback/form-callback';
import carusel from '../blocks/carusel/carusel';
import header from '../blocks/header/header';
import formProfile from '../blocks/form-profile/form-profile';
import sectionProfile from '../blocks/section-profile/section-profile';


$(() => {
  svg4everybody();
  navbar;
  loader;
  slider;
  sliderResizable;
  formContact;
  formModal;
  formStatus;
  formPopup;
  formDirections;
  formList;
  faqlist;
  tvList;
  formCallback;
  carusel;
  header;
  formProfile;
  sectionProfile;
});



// WEBPACK FOOTER //
// ./app/scripts/app.js